import "../css/custom.css";
import "aos/dist/aos.css";
import AOS from "aos";
import { useEffect } from "react";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";
import NavBar from "../components/navbar/NavBar";
import Landing from "../components/landingSection/Landing";
import About from "../components/about/About";
import Projects from "../components/projects/Projects";
import Contact from "../components/contact/Contact";
import Footer from "../components/footer/Footer";

function Home() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <>
      <NavBar active={0} />
      <Landing />
      <About />
      <Projects />
      <Contact />
      <Footer />
    </>
  );
}

export default Home;
